import React from 'react';
import PropTypes from 'prop-types';
import './background.scss';

const Background = ({ background }) => {
	return (
		<div className='Background'>
			
			<div className={'Background-' + background.scenarioId 
				+ ' ' + (background.backgroundId ? background.backgroundId : 'landing')} />
			<div className="Background-overlay" />
		</div>
	);
};

Background.propTypes = {
	background: PropTypes.object.isRequired,
};

export default Background;